import type { SoundAuditionsPayload, SoundAuditionVoice } from "./contracts";

export type AuditionRating = SoundAuditionsPayload["ratings"][number];

export function auditionSampleKey(sample: SoundAuditionVoice) {
  return JSON.stringify([
    sample.voice_id,
    sample.profile_id,
    sample.seed,
    sample.sample_version,
    sample.render_profile_digest,
  ]);
}

export function matchingAuditionRating(
  auditions: SoundAuditionsPayload,
  sample: SoundAuditionVoice,
): AuditionRating | undefined {
  const manifest = auditions.latest_manifest;
  return auditions.ratings
    .filter(
      (rating) =>
        rating.pack_id === manifest?.pack_id &&
        rating.manifest_digest === manifest.manifest_digest &&
        rating.voice_id === sample.voice_id &&
        rating.profile_id === sample.profile_id &&
        rating.seed === sample.seed &&
        rating.sample_version === sample.sample_version &&
        rating.render_profile_digest === sample.render_profile_digest,
    )
    .sort((a, b) => b.updated_at.localeCompare(a.updated_at))[0];
}
